<template>
  <div id="rap">

<headers></headers>

<div class="row widu" style="margin:0 auto;margin-top:10px">
<div class="span6">
<ul class="breadcrumb">
<span style="color:#999">当前位置：</span>
<li>
<a href="/">网站首页</a> <span class="divider">></span>
</li>
<li class="active" style="color:#999">国际报价 </li>
</ul>
</div>
</div>

<div style="margin:0 auto;height:2000px" class="widu" v-if="userinfo.level==2">


<object data="https://www.giazh.com/api/rap" type="application/pdf" width="99%" height="100%">
 
<iframe src="https://www.giazh.com/api/rap" width="98%" height="100%" style="border: none;">
 
浏览器不支持PDF 请下载:  <a href="https://www.giazh.com/api/rap" target="_blank" download="">点击下载</a>
 
</iframe>
 
</object>
 


</div>


<div style="clear:both;"></div>
   <div class="footer" style="margin:0 auto">
                <div class="wrap">
                    <div class="footer-in">

                        <div class="footer-navs">
                            <a href="/" class="fn-index">首页</a><b>|</b>
                            <a href="/vi" class="fn-diamond">在线浏览</a><b>|</b>
                            <a href="/contact" class="fn-login">联系我们</a>
                                                    </div>
                    </div>
                </div>
            </div>

  </div>
</template>

<script>


export default {
  name: 'Rap',
  data(){
  return {
  title:"rap报价表",
  selected_zl: '' ,
  selected_yc: '' ,
  selected_jd: '' ,
  selected_qg: '' ,
  userinfo:{'level':0,'download':0},
  token:localStorage.authorization,
  diamonds:[]
  }
  },
  methods:{
    format: function(value) {
              return  Math.round(value * 100) / 100;
            },
            getUserInfo: function () {
          this.$http.post('https://www.giazh.com/auth/user/userinfo',{},{ headers: {'Authorization': this.token},emulateJSON:true}).then((data)=>{
      console.log('2222',data);
      this.userinfo=data.body;
      this.elementByValue2();
     
      }).catch(err => {
        console.log(err);
            });
    }
    ,
     getData: function (type,value) {
        var url="https://www.giazh.com/api/vi?zl="+this.selected_zl+"&yc="+this.selected_yc+"&jd="+this.selected_jd+"&qg="+this.selected_qg;

	this.$http.get(url).then((data)=>{
        console.log(data);
        this.diamonds=data.body;  
	})


    }
  },
  components:{
  },
  created(){
   this.getUserInfo();
  }
}
</script>



<style scoped>
table td{height:25px;text-align:center;color:#000;word-break: keep-all;white-space:nowrap;}
    .on {
      background: #c7eaf9;
    }
    .off {
      background: #ffffff;
    }

    table td a{color:blue}

</style>


// WEBPACK FOOTER //
// src/components/Rap.vue